module.exports = __webpack_public_path__ + "components/MapControl/svg/Szkoła.svg?59e96ca7";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szkoła.svg
// module id = 2007
// module chunks = 0